"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkerIconManager = void 0;
const constants_1 = require("./constants");
const utils_1 = require("./utils");
class MarkerIconManager {
    constructor() {
        this.ACTIVE_CLASS_NAME = 'active';
        this._defaultDimensions = {
            w: 48,
            h: 48
        };
    }
    attachListeners(markerElement) {
        this._setMarkerIconOnState(markerElement, constants_1.MarkerState.DEFAULT);
        // TODO: handle selected marker event
        // when map provider card is implemented
        // pending implementation in (HSAP-2177)
        this._attachMouseEvents(markerElement);
        this._attachKeyboardEvents(markerElement);
    }
    _removeActiveMarker(target) {
        target.classList.remove(this.ACTIVE_CLASS_NAME);
    }
    _addActiveMarker(target) {
        target.classList.add(this.ACTIVE_CLASS_NAME);
    }
    _attachKeyboardEvents(markerElement) {
        markerElement.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this._setMarkerIconOnState(event.target, constants_1.MarkerState.FOCUSED);
                this._addActiveMarker(event.target);
            }
        });
        // Focus events
        markerElement.addEventListener('focus', ({ target }) => {
            // update to the focussed marker icon only if not active (pressed)
            if (target.classList.contains('active')) {
                return this._removeActiveMarker(target);
            }
            this._setMarkerIconOnState(target, constants_1.MarkerState.HOVERED);
        });
        markerElement.addEventListener('blur', (event) => {
            // revert to default marker icon only if not active (pressed)
            if (event.target.classList.contains('active')) {
                return this._removeActiveMarker(event.target);
            }
            this._setMarkerIconOnState(event.target, constants_1.MarkerState.DEFAULT);
        });
    }
    _attachMouseEvents(markerElement) {
        markerElement.addEventListener('mouseenter', ({ target }) => {
            // update to hovered marker icon
            this._setMarkerIconOnState(target, constants_1.MarkerState.HOVERED);
        });
        markerElement.addEventListener('mouseleave', (event) => {
            // revert to the default marker icon
            if (event.target.classList.contains('active')) {
                return this._removeActiveMarker(event.target);
            }
            this._setMarkerIconOnState(event.target, constants_1.MarkerState.DEFAULT);
        });
        // Click events (temporary state change)
        markerElement.addEventListener('mousedown', (event) => {
            this._setMarkerIconOnState(event.target, constants_1.MarkerState.FOCUSED);
            this._addActiveMarker(event.target);
        });
    }
    removeListeners(markerElement) {
        markerElement.replaceWith(markerElement.cloneNode(true));
    }
    _setMarkerIconOnState(markerElement, state) {
        const iconDataUrl = (0, utils_1.getMarkerIconForState)(state, this._defaultDimensions);
        markerElement.src = iconDataUrl;
        if (state === constants_1.MarkerState.PRESSED) {
            markerElement.setAttribute('aria-pressed', 'true');
        }
        else {
            markerElement.setAttribute('aria-pressed', 'false');
        }
        markerElement.style.zIndex = (state === constants_1.MarkerState.FOCUSED || state === constants_1.MarkerState.HOVERED ? 1000 : 1).toString();
    }
}
exports.MarkerIconManager = MarkerIconManager;
//# sourceMappingURL=markerStatesManager.js.map